import { render, staticRenderFns } from "./quotationOutBuy-tab.vue?vue&type=template&id=24f805c0"
import script from "./quotationOutBuy-tab.vue?vue&type=script&lang=js"
export * from "./quotationOutBuy-tab.vue?vue&type=script&lang=js"
import style0 from "./quotationOutBuy-tab.vue?vue&type=style&index=0&id=24f805c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports